import { HelperResult, SocialLink } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetSocialLinksParams {
  userId: number;
}

interface UpdateSocialLinksParams {
  userId: number;
  context: string;
}

interface UpdateSocialLinksBody {
  linkedInURL?: string;
  facebookURL?: string;
  websiteURL?: string;
  twitterURL?: string;
  githubURL?: string;
}

const { useGet: useGetSocialLinks, useUpdate: useUpdateSocialLinks } = getCRUDHooks({
  entityName: 'socialLinks',
  get({ userId }: GetSocialLinksParams): HelperResult<SocialLink[]> {
    return clientApi.getOCClient().helpers.user.users.id(userId).socialLinks.find();
  },
  update(
    socialLinks: UpdateSocialLinksBody,
    { userId, context }: UpdateSocialLinksParams
  ): HelperResult<SocialLink[]> {
    return clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .socialLinks.partialUpdate('', socialLinks, false)
      .setHeader('X-Request-Context', context)
      .execute();
  },
});

export { useGetSocialLinks, useUpdateSocialLinks };
